import React, { useEffect } from "react";
import "./App.css";
import Layout from "./components/layout-components/layout";
import DrawerMenu from "./components/layout-components/menu/DrawerMenu";
import { DrawerProvider } from "./components/layout-components/menu/menuContext";
import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "./Config/AppConfig";
import GoogleAnalyticsTracker from "./components/analytics/GoogleAnalyticsTracker";

// This component will handle auth redirection
function AuthGuard() {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const token = sessionStorage.getItem("Token");
    
    // Only redirect if user has a full authentication token (after OTP verification)
    // This allows users to go back from OTP page to login page
    if (token && (location.pathname.includes('/login') || location.pathname.includes('/otp-verify'))) {
      navigate("/" + AUTHENTICATED_ENTRY, { replace: true });
    }
  }, [location, navigate]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <DrawerProvider>
        <BrowserRouter>
          <GoogleAnalyticsTracker />
          <AuthGuard />
          <DrawerMenu />
          <Layout />
        </BrowserRouter>
      </DrawerProvider>
    </div>
  );
}

export default App;
